<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="complaintInfoVo.pkid > 0 ? '编辑' : '新建'"
      class="replacementBill-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="complaintInfoVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="系统编号">
            <el-input v-model="complaintInfoVo.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="complaintInfoVo.creatTime"
                style="width: 190px"
                type="datetime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记人">
            <el-input v-model="complaintInfoVo.creatorName" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="complaintInfoVo.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标题">
            <el-input v-model="complaintInfoVo.title" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务发生部门">
            <el-input v-model="complaintInfoVo.businessTypeName" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="complaintInfoVo.pkid>0">
        <el-col :span="8">
          <el-form-item label="物流发货日期">
            <el-date-picker
                v-model="complaintInfoVo.logisticsDeliveryTime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流单号">
            <el-input v-model="complaintInfoVo.logisticsBillNo" disabled placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流备注">
            <el-input v-model="complaintInfoVo.logisticsDesc" disabled placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户联系人">
            <el-input v-model="complaintInfoVo.contact" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户需求交期：" prop="customerDeliveryTime">
            <el-date-picker
                v-model="complaintInfoVo.customerDeliveryTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户联系电话">
            <el-input v-model.trim="complaintInfoVo.telephone" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vm-separate">
        <el-form-item label="是否维修后发货" prop="isFixAfterDelivery">
          <el-radio-group v-model="complaintInfoVo.isFixAfterDelivery">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否过保">
          <el-radio-group v-model="complaintInfoVo.isExpired">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否质量调查">
          <el-radio-group v-model="complaintInfoVo.isQualitySurvey">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="收件人" prop="consignee">
          <el-input v-model="complaintInfoVo.consignee" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="联系电话" prop="consigneePhone">
          <el-input v-model.trim="complaintInfoVo.consigneePhone" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="商务对接人" prop="businessApprovalName">
          <el-select v-model="complaintInfoVo.businessApprovalName" clearable placeholder="请选择审核状态">
            <el-option
                v-for="(item, index) in businessApprovalList"
                :key="index"
                :label="item.employeeName"
                :value="item.employeeName"
                @click.native="selectBusinessApprovalName(item)"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="使用阶段" prop="usePhase">
          <el-select
              v-model="complaintInfoVo.usePhase"
              allow-create
              clearable
              filterable
              placeholder="如有其他，请手动输入！">
            <el-option
                v-for="item in constants.usePhase.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="损坏位置" prop="damageLocation">
          <el-select
              v-model="complaintInfoVo.damageLocation"
              allow-create
              clearable
              filterable
              placeholder="如有其他，请手动输入！">
            <el-option
                v-for="item in constants.damageLocation.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="现场环境" prop="siteEnvironment">
          <el-select
              v-model="complaintInfoVo.siteEnvironment"
              allow-create
              clearable
              filterable
              placeholder="如有其他，请手动输入！">
            <el-option
                v-for="item in constants.siteEnvironment.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="责任判定">
          <el-input v-model="complaintInfoVo.responsibility" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="质量分析">
          <el-input v-model="complaintInfoVo.qualityAnalise" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="送货地址" prop="deliveryAddress">
          <el-input v-model="complaintInfoVo.deliveryAddress" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="产品型号" prop="productLine">
          <el-input v-model="complaintInfoVo.productLine" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </div>
      <el-form-item label="产品编号" prop="productCode">
        <el-input v-model="complaintInfoVo.productCode" type="textarea" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="故障情况描述" prop="note">
        <el-input v-model="complaintInfoVo.note" type="textarea" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="产品信息备注" prop="productNote">
        <el-input v-model="complaintInfoVo.productNote" type="textarea" placeholder="请输入"/>
      </el-form-item>
      <div class="vm-separate">
        <el-form-item label="是否退回件" prop="isSendBack">
          <el-select v-model="complaintInfoVo.isSendBack" placeholder="请选择" @change="getReturnMaterialDetails">
            <el-option label="否" :value="false"/>
            <el-option label="是" :value="true"/>
          </el-select>
        </el-form-item>
        <el-form-item v-if="complaintInfoVo.isSendBack" label="退回单号">
          <el-input v-model.trim="complaintInfoVo.returnBillNo" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
        产品信息-发出
      </div>
      <div>
        <div slot="toolbar">
          <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMaterial.open()">
            新建
          </el-button>
        </div>
        <el-table
            v-if="complaintInfoVo.details.length>0"
            :data="complaintInfoVo.details">
          <el-table-column prop="rowIndex" align="center" label="序号" width="50"/>
          <el-table-column prop="materialNo" align="center" label="物料编号" width="100"/>
          <el-table-column prop="materialName" align="center" label="物料名称"/>
          <el-table-column prop="quantity" align="center" label="数量" width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity" min="1" type="number"/>
            </template>
          </el-table-column>
          <el-table-column prop="note" width="200px" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="90">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <material-select ref="selectMaterial" @select="getDetails"/>
      </div>

      <div v-if="complaintInfoVo.isSendBack">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          产品信息-退回
        </div>
        <div>
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectReturnMaterial.open()">
              新建
            </el-button>
          </div>
          <el-table
              v-if="complaintInfoVo.returnMaterialDetails.length>0"
              :data="complaintInfoVo.returnMaterialDetails">
            <el-table-column prop="rowIndex" align="center" label="序号" width="50"/>
            <el-table-column prop="materialNo" align="center" label="物料编号" width="100"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量" width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" min="1" type="number"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" width="200px" align="center" label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="90">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete2(scope.$index,scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-select ref="selectReturnMaterial" @select="getReturnDetails"/>
        </div>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          订单附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="complaintInfoVo.attachments"
            ref="payData1"
            :data="complaintInfoVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // import loginUtil from "@/util/loginUtil";
  import constants from "@/util/constants";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UploadFile from "@/components/UploadFile";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    name: "ComplaintInfoEdit",
    components: {MaterialSelect, UploadFile, CustomerSelect},
    data() {
      return {
        constants,
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        businessApprovalList: [],
        complaintInfoVo: {
          pkid: 0,
          billNo: "",
          title: "",
          customerId: "",
          customerName: "",
          usePhase: "",
          damageLocation: "",
          siteEnvironment: "",
          businessTypeName: "",
          businessType: "",
          isAfterSale: true,
          isFixAfterDelivery: "",
          isQualitySurvey: "",
          isSendBack: "",
          isExpired: false,
          creatorName: "",
          contact: "",
          telephone: "",
          consignee: "",
          consigneePhone: "",
          status: 0,
          deliveryAddress: "",
          salesOrderType: "",
          salesOrderNo: "",
          customerDeliveryTime: "",
          logisticsType: "",
          logisticsDeliveryTime: "",
          logisticsBillNo: "",
          logisticsDesc: "",
          productLine: "",
          productCode: "",
          returnBillNo: "",
          responsibility: "",
          qualityAnalise: "",
          note: "",
          productNote: "",
          isSubmit: false,
          businessApprovalName: "",
          businessApprovalId: "",
          notifyLists: [],
          returnMaterialDetails: [],
          businessApprovalList: [],
          details: [],
          attachments: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.complaintInfoVo.pkid = row.pkid;
          if (this.complaintInfoVo.pkid > 0) {
            this.getData();
          }
        }
      },
      selectBusinessApprovalName(item) {
        this.complaintInfoVo.businessApprovalId = item.systemUserID;
      },
      getData() {
        this.$http
          .get("basic", `complaintInfoes/${this.complaintInfoVo.pkid}`)
          .then(resp => {
            this.complaintInfoVo = resp.data;
          });
        this.complaintInfoVo.attachments.forEach(row => {
          this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
            if (res.success) {
              row.imgUrl = res.data;
              this.imgUrls.push(row.imgUrl);
            }
          });
        });
      },
      getDetails(row) {
        this.complaintInfoVo.details.push({
          pkid: 0,
          masterId: 0,
          rowIndex: this.complaintInfoVo.details.length + 1,
          materialId: row.id,
          materialName: row.name,
          materialNo: row.no,
          quantity: 1,
          note: "",
        });
        if (this.complaintInfoVo.isSendBack) {
          this.complaintInfoVo.returnMaterialDetails.push({
            pkid: 0,
            masterId: 0,
            rowIndex: this.complaintInfoVo.returnMaterialDetails.length + 1,
            materialId: row.id,
            materialName: row.name,
            materialNo: row.no,
            quantity: 1,
            note: "",
          });
        }
      },
      getReturnMaterialDetails() {
        if (this.complaintInfoVo.isSendBack) {
          let list = this.complaintInfoVo.details;
          list.forEach(item => {
            this.complaintInfoVo.returnMaterialDetails.push(item);
          });
        } else {
          this.complaintInfoVo.returnMaterialDetails = [];
        }
      },
      getReturnDetails(row) {
        this.complaintInfoVo.returnMaterialDetails.push({
          pkid: 0,
          masterId: 0,
          rowIndex: this.complaintInfoVo.returnMaterialDetails.length + 1,
          materialId: row.id,
          materialName: row.name,
          materialNo: row.no,
          quantity: 1,
          note: "",
        });
      },
      oneDelete(index) {
        this.complaintInfoVo.details.splice(index, 1);
        //使tableData重新排序
        this.complaintInfoVo.details.forEach((item, index) => {
          item.rowIndex = index + 1;
        });
      },
      oneDelete2(index) {
        this.complaintInfoVo.returnMaterialDetails.splice(index, 1);
        //使tableData重新排序
        this.complaintInfoVo.returnMaterialDetails.forEach((item, index) => {
          item.rowIndex = index + 1;
        });
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.complaintInfoVo.attachments.push(params);
        }
      },
      selectCustomer(row) {
        console.log(row);
        this.complaintInfoVo.customerName = row.customerName;
        this.complaintInfoVo.customerId = row.customerID;
      },
      fileDelete(row,index) {
        this.complaintInfoVo.attachments.splice(index, 1);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.complaintInfoVo.pkid > 0) {
              this.$http
                .put("basic", "complaintInfoes", this.complaintInfoVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "complaintInfoes", this.complaintInfoVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>